import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from 'chart.js';

// Registering necessary chart components
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);



const options = {
  responsive: true,
  plugins: {
    legend: {
      position: 'top',
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          let label = context.label || '';
          let value = context.raw || '';
          label += ': ' + value;
          return label;
        },
      },
    },
  },
  cutout: '55%', // Creates the donut hole
};

const DonutChart = ({data}) => {
  return (
    <div>
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default DonutChart;